module.exports = __webpack_public_path__ + "static/img/02.c9c0e88.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cultours/tour3/02.jpg
// module id = 54Al
// module chunks = 0